<template>
  <div
    class="body"
    style="background: radial-gradient(circle, rgba(45,46,47,1) 20%, rgba(111,142,148,1) 100%);padding:12% 35% 20% 35%;height: 100vh!important;"
  >
    <div class="vue-template">
      <form>
        <h3>ID</h3>
        <div class="form-group">
          <label>{{ $t("ИДни киритинг") }}</label>
          <input
            type="text"
            ref="focused"
            v-model="code"
            class="form-control form-control-lg"
          />
        </div>

        <button
          type="button"
          class="btn btn-dark btn-lg btn-block"
          @click="Send()"
        >
          {{ $t("Сақлаш") }}
        </button>

        <!-- <p class="forgot-password text-right mt-2 mb-4"></p> -->
        <div class="end">
          <router-link :to="{ path: '/sendsecretcodes' }" style="color: blue!important;">
            {{$t('ИДни унутдингизми')}}?
          </router-link>
                  <router-link :to="{ path: '/registration' }" style="color: blue!important;">
          Регистрация
        </router-link>
        </div>
      </form>
    </div>
  </div>
</template>
<style>
.vue-template form {
  padding: 2% 8%;
  border-radius: 10px;
  background: white;
}

.vs__selected-options {
  max-width: 100% !important;
}
</style>

<script>
export default {
  data() {
    return {
      data: [],
      code:'',
      hostname:'',
      type:'client'
    };
  },
  created(){
    let self=this;
    axios
        .get("http://localhost:3001/api/v1/registration/get-hostname")
        .then(function(response) {
          self.hostname=response.data;
          self.type='baza';
        }).catch(function (error) {
            if (error.request) {
              self.$store.state.errors='';
            } 
  });
  },
  methods: {
    Focus() {
      this.$refs.focused.focus();
    },
    Getsms() {
      let self = this;
      axios
        .get("http://localhost:3001/api/v1/registration/get-sms/"+self.code)
        .then(function(response) {
          if(response.data.error==false){
            self.$router.push({ path: "smsacceptback/"+self.code+'/'+self.hostname });
          }else{
            self.$store.state.errors=response.data.message;
          }
        });
    },
    Send() {
      if(this.type=='baza'){
        this.Getsms();
      }else{
        let self = this;
      const username = self.data.username;
      const password = self.data.password;
      const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64')
      axios
        .get(self.data.url+"/getLoadSms?secret_code="+self.code,{
        headers: {
          'Authorization': `Basic ${token}`
        }})
        .then(function(response) {
          if(response.data.error==false){
            self.$router.push({ path: "smsaccept/"+self.code });
          }else{
            self.$store.state.errors=response.data.message;
          }
        });
      } 
    }
  },
  mounted() {
    let self=this;
    axios
        .get("https://bdm.uz/server/url")
        .then(function(response) {
          self.data = response.data;
        });
    self.Focus();
  }
};
</script>
